import React from 'react'
import $ from 'jquery'
import { addShake } from '../utility/helper'
import { localsMessages } from '../utility/getTemplateData'

let messages = localsMessages('common/amount')
let inputResize = function() {

	let donationVal = $('[name=donationAmount]')
	let	val = donationVal.val().replace(/[^0-9]/g, '')
	let	amountLen = val.length
	let	amountWidth = amountLen * 30 + 20

	let parsedVal = parseFloat(val) || 0
	let parsedValLen = parsedVal.toString().length

	if (parsedValLen <= 3) {
		amountWidth = '110'
	} else if ((parsedValLen === 4)) {
		amountWidth = '136'
	}

	donationVal.css({ width: amountWidth });
}

export default React.createClass({
	propTypes: {
		name: React.PropTypes.string,
		label: React.PropTypes.string,
		value: React.PropTypes.string,
		amount: React.PropTypes.string,
		symbol: React.PropTypes.string,
		code: React.PropTypes.string,
		isEditable: React.PropTypes.string,
		handleAmount: React.PropTypes.func
	},

	getInitialState() {
		return {
			amount: this.props.amount,
			symbol: this.props.symbol,
			code: this.props.code
		};
	},

	componentDidMount() {

		let isEditable = this.props.isEditable
		if (!isEditable) {
			$('[name=donationAmount]').attr('readOnly', true);
		}
		inputResize();
	},

	handleClick(eventName) {

	},

	handleKeyPress(event) {
		var allowedKeys = [16, 46, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57];
		if ($.inArray(event.charCode, allowedKeys) === -1) {
			addShake()
			return
		}
	},

	handleChange(event) {

		let newVal
		let donationVal = event.target.value
		let val = donationVal.replace(/[^0-9]/g, '') || 0

		if (val.length > 9) {
			addShake()
			return
		}

		inputResize();

		if (parseFloat(val) === 0) {
			newVal = '0.00';
		} else if (val.length <= 1) {
			newVal = '0.0' + val;
		} else {

			let str1 = val.split('.').join('');
			if (str1.length === 4) {
				str1 = str1.replace(/^0+/, '');
			}

			if (str1.length === 1) {
				 str1 = '00' + str1
			} else if (str1.length === 2) {
				str1 = '0' + str1
			}
			newVal = str1.slice(0, str1.length - 2) + '.' + str1.slice(str1.length - 2);
		}
		this.setState({ amount: newVal });
		this.props.handleAmount(newVal);
	},

	render() {

		let amountplaceholder = messages.amount && messages.amount.placeholder;

		return (
			<div className="col-xs-12 col-sm-12 col-md-12 amount_holder">
				<div className="inputField" >
					<div className="money_input">
						<div className="amount_currency">
							<span className="amount_currency_symbol" id="currencySymbol">{this.state.symbol}</span>
						</div>
						<input type="text"
							name="donationAmount"
							id="currencyAmount"
							placeholder={amountplaceholder}
							pattern="[0-9]*"
							value={this.state.amount}
							onKeyPress={this.handleKeyPress}
							onChange={this.handleChange}
							onClick={this.handleClick.bind(this, 'donationAmountclick')}
							className="amount_number validate" />
							</div>
				</div>
				<p className="text-center" id="currencyCode">{this.state.code}</p>
			</div>
		);
	}
});



// WEBPACK FOOTER //
// ./common/amount.js